import { componentProvider } from 'js-component-framework';
import getFormattedClassnames from 'utils/getFormattedClassnames';
import MilestonesJumpToDecade from './milestones-jump-to-decade';
import './milestones-jump-to-decade.scss';

const classnames = sciencenewsClassnames['milestones-jump-to-decade'];
const selectors = getFormattedClassnames(classnames);
const { controller, target } = selectors;

const MilestonesJumpToDecadeConfig = {
  name: 'milestones-jump-to-decade',
  component: MilestonesJumpToDecade,
  querySelector: { controller, target },
};

componentProvider(MilestonesJumpToDecadeConfig);
